import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { FilesWithRules } from '../../base/vo/uploadFile';
import { FieldCommonComponent } from '../field-common.component';


@Component({
  selector: 'app-input-upload',
  templateUrl: './input-upload.component.html',
  styleUrls: ['./input-upload.component.scss']
})
export class InputUploadComponent extends FieldCommonComponent implements OnInit {

  @Input() maxAcceptedFiles: number;
  @Input() icon = 'fas fa-file-alt';
  @Input() text: 'Anexar';
  @Input() filesWithRules: FilesWithRules;
  @Input() accept: string;
  @Input() maxFileNumber = 99;

  // tslint:disable-next-line:no-input-rename
  @Input('btn-text') btnText: string;
  @Output() buttonClicked: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('inputFile') inputFile;

  public maxFileSize = 1048576; // 1*1024*1024 = 5 MB
  public erroMessage: string;
  public error = false;

  constructor() {
    super();
  }

  ngOnInit() {
    this.error = this.filesWithRules.isInputDirty && this.filesWithRules.validateRequiredFile;
  }

  onFileChange(event) {
    const fileName = event.target.files[0].name;
    const mimeType = fileName.split('.').pop();

    this.filesWithRules.isInputDirty = true;

    if (event.target.files && event.target.files.length) {
      if (!this.accept.includes(mimeType)) {
        this.erroMessage = 'Arquivo Inválido - O tipo do arquivo é inválido.';
      } else if (event.target.files[0].size > this.maxFileSize) {
        this.erroMessage = 'Arquivo Inválido - O tamanho máximo do arquivo deve ser: 1MB.';
      } else {
        this.erroMessage = '';
        this.filesWithRules.isInputDirty = false;
        this.filesWithRules.filesUpload.files.push(...event.target.files);
      }
    }
    // É necessário limpar o input, só assim pode-se inserir um mesmo arquivo, que acabou de ser excluído.
    this.inputFile.nativeElement.value = '';
  }

  getNumberOfFiles(): number {
    let count = 0;

    if (this.filesWithRules.filesUpload.files) {
      count = count + this.filesWithRules.filesUpload.files.length;
    }

    if (this.filesWithRules.filesUpload.links) {
      count = count + this.filesWithRules.filesUpload.links.length;
    }

    return count;
  }


  openFileBrowser(element) {
    if (this.getNumberOfFiles() >= this.maxFileNumber) {
      return;
    }

    this.buttonClicked.emit(true);
    element.click();
  }

  remove(index: number) {
    this.filesWithRules.filesUpload.files.splice(index, 1);
  }

  removeLink(index: number) {
    this.filesWithRules.filesUpload.links.splice(index, 1);
  }

  pushNewFile(newFile: File) {
    this.filesWithRules.filesUpload.files.push(newFile);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/formulario/input-upload/input-upload.component.ts